import { IHttpService, IPromise } from 'angular';
import HttpService from '../../common/services/http.service';
import { Invoice } from './invoice.model';
import { Address } from '../../common/models/address.model';

/* @ngInject */
export class TbasService {
  constructor(
    private $http: IHttpService,
    private httpService: HttpService,
    private config
  ) {}

  public getInvoiceAddressInfo(): IPromise<Invoice> {
    return this.httpService.extractResponseResult(
      this.$http.get(`hafifmuzik/mobile/paycell/queryInvoiceInfo`)
    );
  }

  public getCityList(): IPromise<any[]> {
    return this.httpService.extractResponseResult(
      this.$http.get(`hafifmuzik/mobile/paycell/getCityList`),
      false
    );
  }

  public getCountyList(cityCode: number): IPromise<any[]> {
    return this.httpService.extractResponseResult(
      this.$http.get(
        `hafifmuzik/mobile/paycell/getCountyList?cityCode=${cityCode}`
      ),
      false
    );
  }

  public createInvoiceAddress(invoice: Invoice): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/createUpdateInvoiceAddress`,
        invoice
      )
    );
  }

  public updateInvoiceAddress(invoice: Invoice): IPromise<boolean> {
    invoice.address.country = this.config.defaultCountry;
    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/createUpdateInvoiceAddress`,
        invoice
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/services/tbas.services.ts